import PlanningMapPage from "../planning-map.js";
import { getCouncilConfig, isAggregateCouncilScope } from "../../lib/councils";

const PUBLIC_COUNCIL_MAP_CACHE_CONTROL = "public, s-maxage=3600, stale-while-revalidate=86400";

export async function getServerSideProps(context) {
  const rawCode = Array.isArray(context.params?.councilCode)
    ? context.params.councilCode[0]
    : context.params?.councilCode;
  const code = String(rawCode || "").trim();
  const lowerCode = code.toLowerCase();
  if (isAggregateCouncilScope(lowerCode)) {
    return {
      redirect: {
        destination: "/planning-map",
        permanent: true,
      },
    };
  }
  const council = getCouncilConfig(lowerCode);

  if (lowerCode === 'london') {
    if (code !== lowerCode) return { redirect: { destination: '/planning-map/london', permanent: true } };
    context.res?.setHeader?.('Cache-Control', PUBLIC_COUNCIL_MAP_CACHE_CONTROL);
    return { props: { councilSlug: 'london' } };
  }

  if (!council) {
    return { notFound: true };
  }

  if (!council.publicEnabled) {
    return { notFound: true };
  }

  if (code !== lowerCode) {
    return {
      redirect: {
        destination: `/planning-map/${council.shortCode}`,
        permanent: true,
      },
    };
  }

  context.res?.setHeader?.("Cache-Control", PUBLIC_COUNCIL_MAP_CACHE_CONTROL);

  return {
    props: {
      councilSlug: council.slug,
    },
  };
}

export default PlanningMapPage;
